const tablet = 520;
const wpDesktop = 783;
const laptop = 1024;
// const wide = 1367;
// const maxContainer = 1440;

module.exports = {
  tablet,
  laptop,
  // wide,
  customMedia: {
    "--tablet": `(min-width: ${tablet}px)`,
    "--wp-desktop": `(min-width: ${wpDesktop}px)`,
    "--laptop": `(min-width: ${laptop}px)`,
    "--menu-laptop": `(min-width: 1150px)`,
    "--events-list-laptop": `(min-width: 1250px)`,
    // "--wide": `(min-width: ${wide}px)`,
    // "--max-container": `(min-width: ${maxContainer}px)`,
    "--less-than-laptop": `screen and (max-width: ${laptop - 1}px)`
  }
};
